module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('web-header')], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(!_vm.checkLoginState) ? _c('login-form') : _c('login-info'), _vm._v(" "), _c('menu-d-m-s-c', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkLoginState),
      expression: "checkLoginState"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('router-view')], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      กรมวิทยาศาสตร์การแพทย์  swindowone@gmail.com\n    ")]), _vm._v(" "), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d40cd736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1094
// module chunks = 1